import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Box } from '@applyboard/ui-components';
import CopyButton from "../../../../components/CopyButton";
import { _TitleSection, SidebarTitleWrapper, SidebarSchool, SidebarProgramDetails, SidebarSchoolName, SidebarCountry, SidebarApplicationId, SidebarSchoolLogo, SidebarLabel } from "../styles";
import { NON_PREMIUM_USER, PREMIUM_STAR } from "../../../../util/cdnAssets";
import getResourceID from "../../../../util/getResourceId";
import { useCountries } from '@applyboard/business-ui-legacy';
import { STUDENT_DASHBOARD_POSITIVE_COLOR, STUDENT_DASHBOARD_POSITIVE_TEXT_COLOR } from "../../../../components/style/colors";
import { usePageSettings } from "../../PageSettings";
var TitleSection = function TitleSection(_ref) {
  var _application$student, _application$student2;
  var hasPermission = _ref.hasPermission,
    application = _ref.application;
  var info = {
    appId: application === null || application === void 0 ? void 0 : application.id
  };
  var _useCountries = useCountries(),
    countryToCodeMapping = _useCountries.countryToCodeMapping;
  if (application !== null && application !== void 0 && application.program) {
    var program = application.program;
    info.programId = program.id || getResourceID(program.href);
    info.programName = program.name;
    info.programLink = program.link;
    info.programLevel = program.level_text;
    info.minimumLevel = program.min_required_level_text;
    info.deliveryMethod = program.delivery_method_text;
  }
  if (application !== null && application !== void 0 && application.school) {
    var school = application.school;
    info.schoolId = school.id || getResourceID(school.href);
    info.schoolName = school.name;
    info.schoolLink = school.link;
    info.schoolLogo = school.logo_url;
    info.countryFlag = school.country_flag;
    info.country = countryToCodeMapping === null || countryToCodeMapping === void 0 ? void 0 : countryToCodeMapping[school.country_code];
  }
  var showId = hasPermission('show_ids');

  // TODO: change this to use a permission instead, as per https://applyboard.atlassian.net/wiki/spaces/APP/pages/2848555120/Customizing+pages+per+persona
  // This is a temp workaround so the feature can be presented in an upcoming town-hall
  var _usePageSettings = usePageSettings(),
    appName = _usePageSettings.appName;
  var profilePictureUrl = (application === null || application === void 0 ? void 0 : (_application$student = application.student) === null || _application$student === void 0 ? void 0 : _application$student.profile_picture) || (application === null || application === void 0 ? void 0 : (_application$student2 = application.student) === null || _application$student2 === void 0 ? void 0 : _application$student2.automatically_extracted_profile_picture) || NON_PREMIUM_USER;
  var src = appName === 'admin' ? profilePictureUrl : NON_PREMIUM_USER;
  var backgroundColor = src === NON_PREMIUM_USER ? 'transparent' : '#F2F2F1';
  return /*#__PURE__*/React.createElement(_TitleSection, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "inline-block",
    position: "relative"
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: "student profile",
    style: {
      width: '140px',
      height: '140px',
      objectFit: 'contain',
      borderRadius: '50%',
      backgroundColor: backgroundColor
    }
  }), application && application.student && application.student.is_premium && /*#__PURE__*/React.createElement(Box, {
    component: "span",
    position: "absolute",
    right: "6px",
    bottom: "9px"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "premium user",
    src: PREMIUM_STAR,
    "data-tip": "This application belongs to a premium student"
  })))), !showId && info.schoolLogo && /*#__PURE__*/React.createElement(SidebarSchoolLogo, null, /*#__PURE__*/React.createElement("img", {
    src: info.schoolLogo,
    alt: info.schoolName
  })), !showId && !info.schoolLogo && /*#__PURE__*/React.createElement(SidebarSchoolLogo, null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "graduation-cap"
  }))), /*#__PURE__*/React.createElement(SidebarTitleWrapper, {
    extraPadding: showId
  }, /*#__PURE__*/React.createElement(SidebarProgramDetails, null, /*#__PURE__*/React.createElement(SidebarCountry, {
    "data-cy": "sidebar-country",
    "data-tip": info.country
  }, /*#__PURE__*/React.createElement("img", {
    src: info.countryFlag,
    alt: info.country
  })), /*#__PURE__*/React.createElement(SidebarSchoolName, null, /*#__PURE__*/React.createElement("a", {
    href: info.schoolLink,
    target: "_blank",
    "data-cy": "school-name-link",
    rel: "noopener noreferrer"
  }, info.schoolName), showId && info.schoolId != null && /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    display: "flex"
  }, /*#__PURE__*/React.createElement("span", {
    "data-cy": "school-id",
    "data-tip": "School ID"
  }, "[", info.schoolId, "]"), /*#__PURE__*/React.createElement(CopyButton, {
    label: info.schoolName,
    dataCy: "copy-school-name",
    tooltip: "Click to copy school's name",
    successMessage: "Copied school's name to clipboard"
  })))), /*#__PURE__*/React.createElement(SidebarSchool, null, /*#__PURE__*/React.createElement("a", {
    href: info.programLink,
    target: "_blank",
    "data-cy": "program-name-link",
    rel: "noopener noreferrer"
  }, info.programName), showId && info.programId != null && /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    display: "flex"
  }, /*#__PURE__*/React.createElement("span", {
    "data-tip": "Program ID"
  }, "[", info.programId, "]"), /*#__PURE__*/React.createElement(CopyButton, {
    label: info.programName,
    dataCy: "copy-program-name",
    tooltip: "Click to copy program's name",
    successMessage: "Copied program's name to clipboard"
  }))), /*#__PURE__*/React.createElement(Box, {
    mt: 0.5,
    "data-cy": "sidebar-level"
  }, /*#__PURE__*/React.createElement(SidebarLabel, null, "Delivery Method:\u2002"), /*#__PURE__*/React.createElement(Box, {
    py: 0.25,
    px: 2,
    borderRadius: 100,
    fontSize: "16",
    display: "inline-block",
    textAlign: "center",
    color: STUDENT_DASHBOARD_POSITIVE_TEXT_COLOR,
    bgcolor: STUDENT_DASHBOARD_POSITIVE_COLOR
  }, info.deliveryMethod)), /*#__PURE__*/React.createElement(Box, {
    mt: 0.5,
    "data-cy": "sidebar-level"
  }, /*#__PURE__*/React.createElement(SidebarLabel, null, "Level:\u2002"), /*#__PURE__*/React.createElement("span", null, info.programLevel)), /*#__PURE__*/React.createElement(Box, {
    mt: 0.5,
    "data-cy": "sidebar-min-required-level"
  }, /*#__PURE__*/React.createElement(SidebarLabel, null, "Required Level:\u2002"), /*#__PURE__*/React.createElement("span", null, info.minimumLevel)), /*#__PURE__*/React.createElement(SidebarApplicationId, {
    "data-cy": "sidebar-app-id"
  }, /*#__PURE__*/React.createElement(SidebarLabel, null, "Application ID:"), /*#__PURE__*/React.createElement("span", null, " ", info.appId), showId && info.appId != null && /*#__PURE__*/React.createElement(CopyButton, {
    label: info.appId.toString(),
    tooltip: "Click to copy application ID",
    successMessage: "Copied application ID to clipboard"
  }))));
};
export default TitleSection;